@let view = data();

<ui-slider
  #headlineGroup="uiEqualHeightGroup"
  uiEqualHeightGroup
  [autoplay]="view.options.autoplay"
  [duration]="view.options.duration"
  [loop]="false"
  [navigation]="view.options.navigation && view.cards.length > 1"
  [spaceBetween]="28"
>
  @for (card of view.cards; track card.id) {
    <div class="key-figure-card-slide" uiSliderSlide>
      <article
        class="key-figure-card background-{{ card.background }}"
        [class.key-figure-card-without-buttons]="!hasAnyButton()"
      >
        @if (card.headline) {
          <ui-headlines
            [uiEqualHeightItem]="headlineGroup"
            equalHeightTarget="h2"
            [data]="{ headline: card.headline }"
            [level]="2"
            class="key-figure-card-headline"
          ></ui-headlines>
        }

        @if (card.image) {
          <div class="key-figure-card-media">
            <ui-image [data]="card.image"></ui-image>
          </div>
        }

        @if (card.content) {
          <div
            [innerHtml]="card.content"
            class="key-figure-card-content rte rte-themed"
            uiHtmlDataLink
          ></div>
        }

        @if (card.keyFigures.length) {
          <div class="key-figure-card-figures">
            @for (keyFigure of card.keyFigures; track $index) {
              <div class="key-figure-card-figure">
                <ui-icon
                  [faName]="keyFigure.icon"
                  class="key-figure-card-figure-icon"
                  faStyle="light"
                ></ui-icon>

                <div class="key-figure-card-figure-text">
                  <strong class="key-figure-card-value">{{ keyFigure.value }}</strong>
                  <span class="key-figure-card-label">{{ keyFigure.label }}</span>
                </div>
              </div>
            }
          </div>
        }

        @if (hasAnyButton()) {
          <div class="key-figure-card-button">
            @if (card.button?.link; as link) {
              @if (link.label) {
                <a [link]="link" matButton="filled" uiContentLink>
                  <ui-icon
                    matButtonIcon
                    class="key-figure-card-button-icon"
                    faName="arrow-up-right"
                    faStyle="light"
                    aria-hidden="true"
                  ></ui-icon>
                  {{ link.label }}
                </a>
              }
            }
          </div>
        }
      </article>
    </div>
  }
</ui-slider>
